import { Injectable } from '@angular/core';
import {AbstractControl, FormControl} from "@angular/forms";

@Injectable({
  providedIn: 'root'
})
export class CustomValidatorsService {
  // public isFloatOrNothing = (control:AbstractControl) => {
  //   console.log(control.value);
  //   console.log(isNaN(control.value));
  //   return !isNaN(control.value) || control.value == '' ? null : {
  //     notFloatOrNothing: true
  //   }
  //}
}
